module.exports = __webpack_public_path__ + "static/spine-fca62325fc2937e9a61ea8af3766ba9e.jpg";